import { TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS } from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const CardDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		default:
			return state;
	}
};

export default CardDetailsReducer;
